module.exports = new __parcel__URL__("template-roadmap-icon.7a9cafc6.svg").toString();